module.exports = __webpack_public_path__ + "static/media/Lottery-banner.80358719.png";